"use strict";

var _regeneratorRuntime = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncToGenerator");

var _classCallCheck = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var bus_http_1 = require("@comunica/bus-http");

var bus_rdf_dereference_1 = require("@comunica/bus-rdf-dereference");

var relative_to_absolute_iri_1 = require("relative-to-absolute-iri");
/**
 * An actor that listens on the 'rdf-dereference' bus.
 *
 * It starts by grabbing all available RDF media types from the RDF parse bus.
 * After that, it resolves the URL using the HTTP bus using an accept header compiled from the available media types.
 * Finally, the response is parsed using the RDF parse bus.
 */


var ActorRdfDereferenceHttpParseBase =
/*#__PURE__*/
function (_bus_rdf_dereference_) {
  _inherits(ActorRdfDereferenceHttpParseBase, _bus_rdf_dereference_);

  function ActorRdfDereferenceHttpParseBase(args) {
    _classCallCheck(this, ActorRdfDereferenceHttpParseBase);

    return _possibleConstructorReturn(this, _getPrototypeOf(ActorRdfDereferenceHttpParseBase).call(this, args));
  }

  _createClass(ActorRdfDereferenceHttpParseBase, [{
    key: "test",
    value: function () {
      var _test = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee(action) {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!(!action.url.startsWith("http:") && !action.url.startsWith("https:"))) {
                  _context.next = 2;
                  break;
                }

                throw new Error('This actor can only handle URLs that start with \'http\' or \'https\'.');

              case 2:
                return _context.abrupt("return", true);

              case 3:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      function test(_x) {
        return _test.apply(this, arguments);
      }

      return test;
    }()
  }, {
    key: "run",
    value: function () {
      var _run = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee2(action) {
        var mediaTypes, acceptHeader, headers, httpAction, httpResponse, url, responseStream, mediaType, parseAction, parseOutput;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return this.mediatorRdfParseMediatypes.mediate({
                  context: action.context,
                  mediaTypes: true
                });

              case 2:
                mediaTypes = _context2.sent.mediaTypes;
                acceptHeader = this.mediaTypesToAcceptString(mediaTypes, this.getMaxAcceptHeaderLength()); // Resolve HTTP URL using appropriate accept header

                headers = new Headers();
                headers.append('Accept', acceptHeader);
                httpAction = {
                  context: action.context,
                  input: action.url,
                  init: {
                    headers: headers
                  }
                };
                _context2.next = 9;
                return this.mediatorHttp.mediate(httpAction);

              case 9:
                httpResponse = _context2.sent;
                url = relative_to_absolute_iri_1.resolve(httpResponse.url, action.url); // The response URL can be relative to the given URL
                // Wrap WhatWG readable stream into a Node.js readable stream
                // If the body already is a Node.js stream (in the case of node-fetch), don't do explicit conversion.

                responseStream = bus_http_1.ActorHttp.toNodeReadable(httpResponse.body); // Only parse if retrieval was successful

                if (!(httpResponse.status !== 200)) {
                  _context2.next = 14;
                  break;
                }

                throw new Error("Could not retrieve ".concat(action.url, " (").concat(httpResponse.status, ": ").concat(httpResponse.statusText || 'unknown error', ")"));

              case 14:
                // Parse the resulting response
                mediaType = httpResponse.headers.has('content-type') ? ActorRdfDereferenceHttpParseBase.REGEX_MEDIATYPE.exec(httpResponse.headers.get('content-type'))[0] : null; // If no media type could be found, try to determine it via the file extension

                if (!mediaType || mediaType === 'text/plain') {
                  mediaType = this.getMediaTypeFromExtension(httpResponse.url);
                }

                parseAction = {
                  baseIRI: url,
                  headers: httpResponse.headers,
                  input: responseStream
                };
                _context2.next = 19;
                return this.mediatorRdfParseHandle.mediate({
                  context: action.context,
                  handle: parseAction,
                  handleMediaType: mediaType
                });

              case 19:
                parseOutput = _context2.sent.handle;
                return _context2.abrupt("return", {
                  url: url,
                  quads: parseOutput.quads,
                  triples: parseOutput.triples
                });

              case 21:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function run(_x2) {
        return _run.apply(this, arguments);
      }

      return run;
    }()
  }, {
    key: "mediaTypesToAcceptString",
    value: function mediaTypesToAcceptString(mediaTypes, maxLength) {
      maxLength -= 10; // Ensure a ',*/*;q=0.1' suffix

      var parts = [];
      var sortedMediaTypes = Object.keys(mediaTypes).map(function (mediaType) {
        return {
          mediaType: mediaType,
          priority: mediaTypes[mediaType]
        };
      }).sort(function (a, b) {
        return b.priority - a.priority;
      });
      var partsLength = 0;
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = sortedMediaTypes[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var entry = _step.value;
          var part = entry.mediaType + (entry.priority !== 1 ? ';q=' + entry.priority.toFixed(3).replace(/0*$/, '') : '');

          if (partsLength + part.length > maxLength) {
            parts.push('*/*;q=0.1');
            break;
          }

          parts.push(part);
          partsLength += part.length;
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return != null) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      if (!parts.length) {
        return '*/*';
      }

      return parts.join(',');
    }
  }]);

  return ActorRdfDereferenceHttpParseBase;
}(bus_rdf_dereference_1.ActorRdfDereferenceMediaMappings);

ActorRdfDereferenceHttpParseBase.REGEX_MEDIATYPE = /^[^ ;]*/;
exports.ActorRdfDereferenceHttpParseBase = ActorRdfDereferenceHttpParseBase;